var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var oab_year_suffix = settings.oab_year_suffix || '';
  var oab_month_suffix = settings.oab_month_suffix || '';
  var oab_day_suffix = settings.oab_day_suffix || '';
  var oab_postcode_override = settings.oab_postcode_override || 0;
  var oab_phone_override = settings.oab_phone_override || 0;
  var oab_date_format_with_dot = settings.oab_date_format_with_dot || 0;

  /* Concrete View */
  apptBook.ConfirmSection = function (container) {
    apptBook.ConfirmSection.superclass.constructor.call(this);
    this.id = 'confirmation';
    this.container = container;
    this.confContainer = container.find('.confirmation-container');
    this.services = this.confContainer.find('.js-services');
    this.location = this.confContainer.find('.location');
    this.dateTime = this.confContainer.find('.date-time');
    this.artistName = this.confContainer.find('.artist');
    this.legalCopy = this.container.find('.services-legal-copy');
    this.minLabel = this.container.attr('data-minutes-label');
    this.separator = this.container.attr('data-lessons-separator');
    this.phoneFormat = this.container.attr('data-phone-format');
    this.dateFormat = this.container.attr('data-date-format');
    this.currency = this.container.attr('data-currency-symbol');
    this.months = this.container.attr('data-month-names').split(',');
    this.myappointmentbutton = this.container.find('a.view-appts-button');
    this.totalDuration = 0;
    this.isVirtual = 0;
  };

  ctrlopt.extend(apptBook.ConfirmSection, apptBook.AbstractSection);

  apptBook.ConfirmSection.prototype.onUpdate = function (data) {
    var me = this,
      aPgName = document.title + ' - Confirmation';
    var config = Drupal.settings.appointment_booking_main_collection;

    if (data.sectionId === this.id) {
      this.confData = data.params;

      if (this.confData.counter.calendars[0].virtual === '1') {
        this.isVirtual = 1;
      }

      if (config.display_sessions_price && config.price_legal_copy) {
        me.legalCopy.show().html(config.price_legal_copy);
      } else {
        me.legalCopy.hide();
      }

      generic.jsonrpc.fetch({
        method: 'user.json',
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();

          var modCounterData = apptBook.geoLoc.mergeGeoLocWithCounters(me.confData.counter);

          me.confData.counter = modCounterData ? modCounterData[0] : me.confData.counter;

          me.buildServices(me.confData, me.userData);
          if (me.isVirtual) {
            me.buildVirtualAppointmentLink(me.confData);
          } else {
            me.buildLocation(me.confData.counter);
          }
          me.buildDateTime(me.confData);
          me.buildArtistName(me.confData.calendar);
          if (me.isVirtual) {
            me.container.find('.virtual_oab_content').removeClass('hidden');
            $('.appt-book-page-header .physical_oab_content').addClass('hidden');
          } else {
            me.container.find('.physical_oab_content').removeClass('hidden');
            $('.appt-book-page-header .virtual_oab_content').addClass('hidden');
          }
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
        }
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildServices = function (data, user) {
    var $sContainer,
      cName,
      sName,
      sDetails,
      serviceData,
      myNode,
      myCName,
      mySName,
      mySTime,
      mySPrice,
      sDuration;

    me = this;

    var config = Drupal.settings.appointment_booking_main_collection;
    var servicesData = data.services;
    var cServices = this.model.getCounterServices(data.counter_id);

    this.serviceCont = this.services.find('.js-service');

    for (var i = 0, len = servicesData.length; i < len; i += 1) {
      serviceData = servicesData[i];

      var service = this.model.getService(serviceData.online_content_id);

      $sContainer = this.serviceCont.clone();
      cName = $sContainer.find('.js-customer-name');
      sName = $sContainer.find('.js-service-name');
      sDetails = $sContainer.find('.js-service-details');

      myCName = window.apptBookFirstName;
      mySName = serviceData.name;
      mySTime = serviceData.total_duration;
      mySPrice = parseInt(serviceData.price);
      me.totalDuration += parseInt(mySTime);

      if (config.display_sessions_price && mySPrice > 0) {
        sName.html(mySName + ' <span class="price">(' + me.currency + mySPrice + ')*</span>');
      } else {
        sName.html(mySName);
      }

      cName.html(myCName);
      sDetails.html(
        mySTime + ' ' + this.minLabel + ' ' + this.separator + ' ' + this.currency + mySPrice
      );

      sDuration = $sContainer.find('.appt-date-duration');
      sDuration.html(mySTime + ' ' + this.minLabel);
      this.services.append($sContainer);
    }

    this.services.find('.js-service').first().remove();
  };

  apptBook.ConfirmSection.prototype.buildVirtualAppointmentLink = function (data) {
    var virtualMeetingLink = data.virtual_meeting_link,
      apptHyperlink = this.location.find('.virtual-appt-link');

    if (virtualMeetingLink) {
      apptHyperlink.attr('href', virtualMeetingLink).text(virtualMeetingLink);
      apptBook.equalHeights($('.confirmation-container__item'));
    }
  };

  apptBook.ConfirmSection.prototype.buildLocation = function (data) {
    var googleStr = 'https://www.google.com/maps?daddr=',
      name = data.name,
      addr1 = data.address1,
      addr2 = data.address2,
      town = data.town,
      state = data.state ? data.state.short_name : data.county,
      postCode = oab_postcode_override
        ? data.postcode.replace(/(\d{3})(\d{4})/, '$1-$2')
        : data.postcode,
      phone = oab_phone_override
        ? data.phone.replace(/(\d{2})(\d{4})(\d{4}|\d{5})/, '$1-$2-$3')
        : data.phone,
      email = data.email,
      nameNode = this.location.find('.location-name'),
      addrNode = this.location.find('.location-address'),
      addr2Node = this.location.find('.location-address2'),
      townNode = this.location.find('.location-town'),
      townPostNode = this.location.find('.location-town-postcode'),
      stateNode = this.location.find('.location-state'),
      phoneNode = this.location.find('.location-phone'),
      getDir = this.location.find('.location-direction-links');

    if (name) {
      nameNode.html(name);
      googleStr += name;
    } else {
      nameNode.hide();
    }

    if (addr1) {
      addrNode.html(addr1);
      googleStr += '+' + addr1;
    } else {
      addrNode.hide();
    }

    if (addr2) {
      addr2Node.html(addr2);
      googleStr += '+' + addr2;
    } else {
      addr2Node.hide();
    }

    if (town) {
      townNode.html(town);
      googleStr += '+' + town;
    } else {
      townNode.hide();
    }

    if (state) {
      stateNode.html(state);
      googleStr += '+' + state;
    } else {
      stateNode.hide();
    }

    if (postCode) {
      townPostNode.html(postCode);
      googleStr += '+' + postCode;
    } else {
      townPostNode.hide();
    }

    if (phone) {
      if (phone.match(/\d{10}/)) {
        if (this.phoneFormat == 'no-format') {
          // Do not modify the format of the phone number
        } else {
          // Default format
          phone = phone.substr(0, 3) + '-' + phone.substr(3, 3) + '-' + phone.substr(6, 4);
        }
      }
      phoneNode.html(phone);
      if (typeof phoneNode.attr('href') !== 'undefined') {
        phoneNode.attr('href', 'tel:' + phone);
      }
    } else {
      phoneNode.hide();
    }

    getDir.attr('href', googleStr);
  };

  apptBook.ConfirmSection.prototype.buildDateTime = function (data) {
    var m,
      d,
      y,
      h1,
      h2,
      mi,
      hSuffix1,
      hSuffix2,
      apptDayStr,
      apptHrStr,
      apptDurStr,
      me = this,
      apptStartDate = this.convertTimeString(data.start_time),
      apptEndDate = new Date(apptStartDate.getTime()),
      dateNode = this.dateTime.find('.appt-date'),
      dateDay = this.dateTime.find('.appt-date-day'),
      dateHours = this.dateTime.find('.appt-date-hours'),
      dateDuration = this.services.find('.appt-date-duration'),
      calDateLink = this.dateTime.find('.date-time-links'),
      calLocation;

    me.calContainer = me.container.find('.appt-date-cal');

    me.timeFormat = me.calContainer.data('time-format');
    me.addCalLink = me.calContainer.find('.add-cal-link');
    me.calLinksCont = me.calContainer.find('.cals-container');
    me.calLinks = me.calContainer.find('.date-time-link');

    if (me.calContainer.length) {
      var typeClass = this.isVirtual ? '.virtual' : '.physical',
        addCalLink = me.calContainer.find('.add-cal-link'),
        calLinks = me.calContainer.find('.date-time-link'),
        addCalTitle = me.calContainer.find('.add-cal-title').html() || 'Aveda Appointment',
        addCalDesc =
          me.calContainer.find('.add-cal-desc' + typeClass).html() ||
          "Your Makeup Appointment is booked! Please arrive ten minutes before your lesson. We're looking forward to seeing you in person.",
        addr1 = data.counter.address1 || '',
        addr2 = data.counter.address2 || '',
        town = data.counter.town || '',
        state = data.state ? data.state.short_name : data.county,
        postcode = data.counter.postcode || '',
        virtMeetingLink = data.virtual_meeting_link;

      if (this.isVirtual) {
        calLocation = virtMeetingLink;
      } else {
        calLocation = addr1 + ', ' + town + ', ' + state + ' ' + postcode;
      }
    }

    apptEndDate.setTime(apptEndDate.getTime() + parseInt(me.totalDuration) * 60000);

    m = this.months[apptStartDate.getMonth()];
    d = apptStartDate.getDate();
    y = apptStartDate.getFullYear();

    h2 = apptEndDate.getHours();
    mi = apptEndDate.getMinutes() > 0 ? ':' + apptEndDate.getMinutes() : ':00';
    if (me.timeFormat == '12h') {
      hSuffix1 = h2 < 12 ? 'AM' : 'PM';
      h2 = ((h2 + 11) % 12) + 1 + mi + ' ' + hSuffix1;
    } else {
      h2 = h2 + mi;
    }

    h1 = apptStartDate.getHours();
    mi = apptStartDate.getMinutes() > 0 ? ':' + apptStartDate.getMinutes() : ':00';
    hSuffix2 = h1 < 12 ? 'AM' : 'PM';
    // hSuffix2 = hSuffix1 != hSuffix2 ? hSuffix2 : "";
    if (hSuffix1 != hSuffix2) {
      hSuffix2 = '';
    }
    if (me.timeFormat == '12h') {
      h1 = ((h1 + 11) % 12) + 1 + mi + hSuffix2;
    } else {
      h1 = h1 + mi;
    }

    if (me.dateFormat === 'yyyymmdd') {
      apptDayStr = y + oab_year_suffix + ' ' + m + oab_month_suffix + ' ' + d + oab_day_suffix;
    } else if (me.dateFormat === 'ddmm') {
      if (oab_date_format_with_dot) {
        apptDayStr = d + '. ' + m + ' ' + y;
      } else {
        apptDayStr = d + ' ' + m + ' ' + y;
      }
    } else {
      apptDayStr = m + ' ' + d + ', ' + y;
    }

    apptHrStr = h1;
    apptDurStr = me.totalDuration + ' ' + this.minLabel;

    dateDay.html(apptDayStr);
    dateHours.text(apptHrStr);

    if (me.calContainer.length) {
      me.myCalendar = createCalendar({
        data: {
          device_mobile: site.client.isMobile,
          title: addCalTitle, // Event title
          start: new Date(apptStartDate.getTime()), // Event start date
          duration: me.totalDuration, // Event duration (IN MINUTES)
          end: new Date(apptEndDate.getTime()), // You can also choose to set an end time.
          address: calLocation,
          description: addCalDesc
        }
      });

      me.calLinks.each(function () {
        var $this = $(this);
        var calID = $(this).attr('data-cal'),
          data = $.grep(me.myCalendar, function (el, i) {
            if (el.calId.toLowerCase() === calID) {
              return el.calHref;
            }
          });
        var dataUri = data[0].calHref;

        createDownloadLink($this, dataUri, calID, 'calendar.ics');
        $this.on('click', function () {
          me.calLinksCont.toggleClass('expanded');
        });

        function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
          var dateUriIE = '';
          var blobObject = null;

          if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
            dateUriIE = dataUri.split(',')[1];
            dateUriIE = decodeURIComponent(dateUriIE);
            var fileData = [dateUriIE];

            blobObject = new Blob(fileData);
            $(anchorSelector).click(function (e) {
              e.preventDefault();
              window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            });
          } else {
            $(anchorSelector).attr('href', dataUri);
          }
        }
      });

      me.addCalLink.on('click', function () {
        me.calLinksCont.toggleClass('expanded');
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildArtistName = function (data) {
    var aName = data.public_name,
      aNameNode = this.artistName.find('.artist-name');

    aNameNode.html(aName);
  };

  apptBook.ConfirmSection.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var view = new apptBook.ConfirmSection($('#confirmation'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
